/**
 * Marks an element whose markup carries personal data that session replay must not
 * capture. Attribute values are the case this exists for: Amplitude documents that its
 * masking covers text, not HTML attributes, so a personalized `href` survives masking
 * and has to be blocked outright.
 *
 * Blocking replaces the element with a placeholder, so anything wearing this class is
 * invisible in replay — pair it with an explicit event if its use needs measuring.
 */
export const REPLAY_BLOCK_CLASS = 'replay-block'

export const REPLAY_BLOCK_SELECTOR = `.${REPLAY_BLOCK_CLASS}`
